import { render, staticRenderFns } from "./WorkBench.vue?vue&type=template&id=2d969a48"
import script from "./WorkBench.vue?vue&type=script&lang=js"
export * from "./WorkBench.vue?vue&type=script&lang=js"
import style0 from "./WorkBench.vue?vue&type=style&index=0&id=2d969a48&prod&lang=less"
import style1 from "./WorkBench.vue?vue&type=style&index=1&id=2d969a48&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports